var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleToilet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.258,
    height: 87.544,
    viewBox: "0 0 37.258 87.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-7353.29-5281.991a6.846,6.846,0,0,1-6.838-6.838,6.783,6.783,0,0,1,2-4.835,6.789,6.789,0,0,1,4.834-2,6.848,6.848,0,0,1,6.84,6.838,6.8,6.8,0,0,1-2,4.835A6.8,6.8,0,0,1-7353.29-5281.991Zm0-9.97a3.106,3.106,0,0,0-2.212.917,3.107,3.107,0,0,0-.919,2.215,3.134,3.134,0,0,0,3.131,3.13,3.11,3.11,0,0,0,2.215-.916,3.115,3.115,0,0,0,.916-2.214A3.136,3.136,0,0,0-7353.29-5291.96Z",
    transform: "translate(7371.917 5295.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-7349.207-4994.348a5.978,5.978,0,0,1-4.25-1.762,5.973,5.973,0,0,1-1.76-4.25v-36.354a1.853,1.853,0,0,1,1.854-1.854,1.851,1.851,0,0,1,1.853,1.854v36.354a2.293,2.293,0,0,0,.675,1.629,2.3,2.3,0,0,0,1.629.675,2.307,2.307,0,0,0,2.3-2.3v-36.354a1.853,1.853,0,0,1,1.853-1.854h0a1.855,1.855,0,0,1,1.855,1.854v36.354A6.019,6.019,0,0,1-7349.207-4994.348Z",
    transform: "translate(7367.834 5081.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 15.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-7428.242-5167.058a1.836,1.836,0,0,1-.949-.264,1.853,1.853,0,0,1-.639-2.542l2.654-4.429a57.053,57.053,0,0,0,7.351-19.972l.08-.49c.152-.9.252-1.495.286-1.68a8.1,8.1,0,0,1,7.973-6.66,1.853,1.853,0,0,1,1.854,1.854,1.853,1.853,0,0,1-1.854,1.854,4.394,4.394,0,0,0-4.326,3.613c-.028.161-.137.81-.276,1.632l-.08.49a60.79,60.79,0,0,1-7.828,21.266l-2.651,4.428A1.854,1.854,0,0,1-7428.242-5167.058Z",
    transform: "translate(7430.093 5203.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-7311.809-5167.058a1.856,1.856,0,0,1-1.592-.9l-2.651-4.428a60.792,60.792,0,0,1-7.829-21.266l-.08-.479c-.138-.827-.247-1.482-.276-1.643a4.393,4.393,0,0,0-4.325-3.613,1.853,1.853,0,0,1-1.854-1.854,1.854,1.854,0,0,1,1.854-1.854,8.1,8.1,0,0,1,7.973,6.66c.035.186.136.786.286,1.693l.08.478a57.02,57.02,0,0,0,7.354,19.972l2.651,4.429a1.856,1.856,0,0,1-.639,2.542A1.841,1.841,0,0,1-7311.809-5167.058Z",
    transform: "translate(7347.214 5203.094)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleToilet);
export default __webpack_public_path__ + "static/media/FemaleToilet.0cb9da8c.svg";
export { ForwardRef as ReactComponent };